module.exports = __webpack_public_path__ + "img/sperziebonen-in-pan.a0d31b9d.jpg";